<template>
    <div>
        <div class="row" v-for="inspection_unmeasurable in inspection_externals"
             v-if="inspection_unmeasurable.inspection_type == 'UNMEASURABLE' && inspection_unmeasurable.section_id == section_id">
            <div class="col-lg-12 elements-in-section">
                <h2 class="title">
                    {{ inspection_unmeasurable.element.name }}
                    <span v-if="inspection_unmeasurable.plastic_state == '1'"> (пластиковый)</span>
                </h2>
                <div class="title-photo">
                    <h3>Повреждения</h3>
                </div>
                <table class="table table-striped">
                    <tbody>
                    <tr v-for="damage in inspection_unmeasurable.damages">
                        <td>{{ damage.short_name }}</td>
                        <td>{{ damage.name }}</td>
                    </tr>
                    </tbody>
                </table>

                <div class="car_comment">
                    <div class="comment_body">{{ inspection_unmeasurable.comment }}</div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'InspectionExternalUnmeasurable',
        props: [
            'inspection_externals',
            'section_id'
        ],
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// InspectionExternalUnmeasurable.vue?4cdd39ea